import { useParams } from "react-router-dom";
import { useIsAdmin } from '../../hooks/isAdmin';

import { TagsPicker } from './TagsPicker';

import { Icon, Label } from 'semantic-ui-react'

import { useQuery, gql, useMutation } from '@apollo/client';

import { GET_TAGS as GET_POSSIBLE_TAGS } from '../../queries/tags';

const UPDATE_PERSON_TAGS = gql`
mutation UpdateUserTags($userId: Int!, $tagIds: [Int!]!) {
    updateUserTags(userId: $userId, tagIds: $tagIds) {
            status
    }
}
`;

const PersonTags = ({ tags, refetchPerson }: { tags: any, refetchPerson: any }) => {
    let { id: userId } = useParams();
    const isAdmin = useIsAdmin();

    const [updateUserTags] = useMutation(UPDATE_PERSON_TAGS);

    const { loading, error, data} = useQuery(GET_POSSIBLE_TAGS, {
        variables: {
            showPeopleTags: true,
            showCourseTags: false,
            // Roles are assigned on /admin/roles, not here. A role tag picked on a profile
            // really does grant the role — the mirror hook sees the tag write — so leaving them
            // in this list is a second, scopeless way of making somebody an admin.
            excludeRoleTags: true,
        }
    });

    if (!isAdmin) {
        return (tags || []).map((tag: any) => (
          <Label size='small'>
            <Icon name='tag' /> {tag.name}
          </Label>
        ));
    }

    return (
        <TagsPicker
            tags={tags}
            refetchParent={refetchPerson}
            loading={loading}
            error={error}
            data={data}
            updateTags={updateUserTags}
            payload={{ userId: Number(userId) }}
        />
    )
}

export { PersonTags }
